<script>
import { mapActions, mapGetters } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  name: "UpdateApp",
  components: { Multiselect },
  data() {
    return {
      selectedVersion: "",
      macAddress: "",
      kiosk_id: "",
      kiosk_name: "",
    };
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo", "getModalState"]),
    ...mapGetters("daemon", ["getLoading", "getAppVersions"]),
  },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("installApp_" + this.kiosk_id);
    },
  },
  methods: {
    ...mapActions("daemon", ["updateApp", "fetchAppVersions"]),
    ...mapActions("grid", ["getSelectedRows"]),
    onSubmit() {
      this.updateApp({
        kiosk_name: this.kiosk_name,
        macAddress: this.macAddress,
        version: this.selectedVersion.name,
      })
        .then(() => this.$bvModal.hide("installApp_" + this.kiosk_id))
        .catch(() => this.$bvModal.hide("installApp_" + this.kiosk_id));
    },
  },
  beforeMount() {
    this.macAddress = this.getModalInfo.mac_address;
    this.kiosk_id = this.getModalInfo.id;
    this.kiosk_name = this.getModalInfo.name;
    this.fetchAppVersions();
  },
};
</script>

<template>
  <div class="update-user-type-wrapper">
    <h4 class="allareakiosk-header">Install App</h4>
    <div class="form-groups multi-inputs">
      <!-- site  -->
      <b-form-group>
        <multiselect
          id="selectedVersion"
          v-model="selectedVersion"
          :options="getAppVersions"
          placeholder="App Version"
          :show-labels="true"
          label="name"
        />
      </b-form-group>
    </div>
    <div class="actionsline-inside"></div>
    <div class="actions-btns">
      <button
        :disabled="getLoading || !selectedVersion"
        class="submit-btn btn btn-primary modal-button px-3 mr-2"
        size="md"
        @click="onSubmit"
      >
        <i v-if="getLoading" class="submit-btn btn btn-primary add-submit"></i>
        Install
      </button>
      <button
        class="btn btn-outline-danger cancel-reject"
        @click="$bvModal.hide('installApp_' + kiosk_id)"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<style lang="scss">
div[id*="installApp_"] {
  div[class*="modal-content"] {
    width: 579px;
    position: absolute;
    float: inline-start;
    inset-inline-start: 50%;
    top: 50%;
    transform: translate(-50%, 30%);
    div[class*="modal-body"] {
      padding: 0px !important;
      .update-user-type-wrapper {
        padding-top: 41px;
        padding-inline-end: 0px;
        padding-bottom: 0px;
        padding-inline-start: 46px;
        h4.allareakiosk-header {
          font-weight: 700;
          font-size: 17px;
          line-height: 20px;
          color: #000000;
          margin-top: 0px;
          margin-inline-end: auto;
          margin-bottom: 51px;
          margin-inline-start: 0px;
          text-align: center;
        }

        .multi-inputs {
          .multiselect {
            width: 415px;
          }

          .multiselect__tags {
            height: 55px !important;
            background: #f2f2f2 !important;
            border-radius: 4px !important;
            border: none !important;
            display: flex;
            align-items: center;
            .multiselect__single {
              background: #f2f2f2 !important;
              font-weight: 700 !important;
              font-size: 16px !important;
              line-height: 17px !important;
              width: 300px !important;
              letter-spacing: 0.25px;
              color: rgba(0, 0, 0, 0.87) !important;
              opacity: 0.8;
            }
            .multiselect__placeholder {
              font-weight: 700 !important;
              font-size: 16px !important;
              line-height: 17px !important;
              padding-inline-start: 10px;
              letter-spacing: 0.25px;
              color: #787878 !important;
            }
          }
          input#selectedVersion {
            background: #f2f2f2 !important;
            &::placeholder {
              font-weight: 700;
              font-size: 16px;
              line-height: 17px;
              letter-spacing: 0.25px;
              color: rgba(0, 0, 0, 0.87);
              opacity: 0.8;
            }
          }
          label#loginMode__BV_label_ {
            font-weight: 700;
            font-size: 16px;
            line-height: 17px;
            margin-bottom: 27px;
            letter-spacing: 0.25px;
            color: #787878;
          }
          .custom-activeRadio .custom-radio .custom-control-label span {
            padding-inline-start: 20px !important;
            padding-inline-end: 10px !important;

            font-weight: 400;
            font-size: 16px;
            line-height: 17px;
            letter-spacing: 0.25px;
            color: rgba(96, 96, 96, 0.87);
          }
          .custom-activeRadio
            .custom-radio
            .custom-control-input:checked
            ~ .custom-control-label
            span {
            font-weight: 700;
            font-size: 16px;
            line-height: 17px;
            letter-spacing: 0.25px;
            color: #103f5e;
          }

          label#autoSignOut__BV_label_ {
            font-weight: 700;
            font-size: 16px;
            line-height: 17px;
            margin-bottom: 14px;
            letter-spacing: 0.25px;
            color: #787878;
          }
        }
        .actionsline-inside {
          background: #707070;
          height: 1px;
          opacity: 0.15;
          margin-top: 43px;
          margin-bottom: 20px;
          margin-inline-end: 36px !important;
        }
        .actions-btns {
          margin-inline-end: 36px;
          margin-bottom: 21px;
          display: flex;
          align-items: center;
          justify-content: center;
          .submit-btn {
            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
            color: #ffffff !important;
            margin-inline-end: 15px !important;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .cancel-reject {
            margin-inline-start: 15px;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
